exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".xue-affix {\n  width: 100%; }\n  .xue-affix-wrapper {\n    width: 100%;\n    height: 100%;\n    z-index: 100; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/packages/affix/style/index.scss
// module id = 194
// module chunks = 0